/* eslint-disable camelcase */
import { MESSAGE_TYPES, RESPONSE_TYPES, MESSAGE_ROLES } from 'ai/constants/superchat';

function mapPreviousConversations(conversations) {
    if (!conversations || !conversations.messages || conversations.messages.length === 0) {
        return [];
    }

    const { messages, sessions } = conversations;

    const sessionMap = new Map();

    if (sessions) {
        sessions.forEach(session => {
            sessionMap.set(session.session_id, session);
        });
    }

    // Group messages by session_id
    const messagesBySession = new Map();

    messages.forEach(message => {
        if (!messagesBySession.has(message.session_id)) {
            messagesBySession.set(message.session_id, []);
        }

        messagesBySession.get(message.session_id).push(message);
    });

    const result = [];

    // Get unique session IDs from messages and sort by creation time
    const sessionIds = Array.from(messagesBySession.keys());
    const sortedSessions = sessionIds
        .map(sessionId => ({
            sessionId,
            session: sessionMap.get(sessionId),
            messages: messagesBySession.get(sessionId)
        }))
        .sort((a, b) => {
            // Sort by session creation time if available, otherwise by first message time
            const aTime = a.session?.created_at || a.messages[0]?.created_at;
            const bTime = b.session?.created_at || b.messages[0]?.created_at;

            return new Date(aTime) - new Date(bTime);
        });

    sortedSessions.forEach(({ sessionId, session, messages: sessionMessages }) => {
        // Add contextual divider for the session
        if (session) {
            const dividerData = {
                response_type: RESPONSE_TYPES.CONTEXTUAL_DIVIDER,
                session_id: sessionId,
                data: {
                    entrypoint: session.entrypoint,
                    category: session.category,
                    products: session.products,
                    search_term: session.search_term
                }
            };

            result.push(dividerData);
        }

        // Sort messages within the session by creation time
        const sortedMessages = sessionMessages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

        // Process messages in this session
        sortedMessages.forEach(conv => {
            if (conv.role === MESSAGE_ROLES.USER) {
                if (/^<event>[\s\S]*<\/event>$/.test((conv.content || '').trim())) {
                    return;
                }

                result.push({
                    response_type: MESSAGE_TYPES.USER_QUERY,
                    data: {
                        query: conv.content
                    }
                });
            } else if (conv.role === MESSAGE_ROLES.ASSISTANT && conv.products && conv.products.length > 0) {
                if (conv.content) {
                    result.push({
                        response_type: MESSAGE_TYPES.USER_QUERY_RESPONSE,
                        data: {
                            stream: false,
                            summary: conv.content
                        }
                    });
                    result.push({
                        response_type: MESSAGE_TYPES.PRODUCTS_RESPONSE,
                        data: {
                            products: conv.products,
                            view_all_url: conv.view_all_url
                        }
                    });
                } else {
                    result.push({
                        response_type: MESSAGE_TYPES.PRODUCTS_RESPONSE,
                        data: {
                            products: conv.products,
                            view_all_url: conv.view_all_url
                        }
                    });
                }
            } else {
                result.push({
                    response_type: MESSAGE_TYPES.USER_QUERY_RESPONSE,
                    data: {
                        stream: false,
                        summary: conv.content
                    }
                });
            }
        });
    });

    return result;
}

export default mapPreviousConversations;
